import type { ReactNode } from 'react';
import { createMarkup, formatAIResponse } from '../utils/markdown';

interface ConversationMessageProps {
  question?: string;
  answer?: string;
  feedback?: string;
  questionLabel?: string;
  scorePercentage?: number;
  scoreBadge?: ReactNode;
  showEvaluation?: boolean;
}

const FormattedText = ({ text, className = '' }: { text: string; className?: string }) => (
  <div
    className={`ai-response${className ? ` ${className}` : ''}`}
    dangerouslySetInnerHTML={createMarkup(formatAIResponse(text))}
  />
);

export function ConversationMessage({
  question,
  answer,
  feedback,
  questionLabel,
  scorePercentage,
  scoreBadge,
  showEvaluation = false,
}: ConversationMessageProps) {
  const evaluationClass = scorePercentage === undefined
    ? 'neutral'
    : scorePercentage >= 60
      ? 'correct'
      : 'incorrect';

  return (
    <div className="chat-message-group">
      {question && (
        <div className="chat-bubble-question">
          <div className="chat-bubble-content">
            {questionLabel && <div className="admin-message-label">{questionLabel}</div>}
            <FormattedText text={question} />
          </div>
        </div>
      )}
      {answer && (
        <div className="chat-bubble-answer">
          <div className={`chat-bubble-content ${showEvaluation ? `chat-review-block ${evaluationClass}` : 'neutral'}`}>
            {showEvaluation && scoreBadge}
            <div className={showEvaluation ? 'chat-review-section' : undefined}>
              <FormattedText text={answer} />
            </div>
            {showEvaluation && feedback && (
              <>
                <hr className="chat-review-divider" />
                <div className="chat-review-section">
                  <FormattedText text={feedback} />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
